var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.getClassName("add-cart") }, [
    _c("div", { class: _vm.getClassName("add-cart__summary") }, [
      _vm._v("価格")
    ]),
    _vm._v(" "),
    _vm.item.category.id != 13 && _vm.item.category.id != 2
      ? _c("div", { class: _vm.getClassName("add-cart__text") }, [
          _vm._v("\n    ギフトラッピングは注文画面でお選びいただけます。\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.getTotalPrice
      ? _c("div", { class: _vm.getClassName("add-cart__total") }, [
          _vm._v("\n    合計：\n    "),
          _c("span", { class: _vm.getClassName("add-cart__st") }, [
            _vm._v(_vm._s(_vm.getTotalPrice))
          ]),
          _vm._v(" "),
          _c("span", { class: _vm.getClassName("add-cart__unit") }, [
            _vm._v("円")
          ]),
          _vm._v("\n    （税込）\n  ")
        ])
      : _c("div", { class: _vm.getClassName("add-cart__total") }, [
          _vm._v("購入内容に不備があります。")
        ]),
    _vm._v(" "),
    _vm.enableCart
      ? _c(
          "button",
          {
            class: _vm.getClassName("add-cart__button"),
            attrs: { type: "button", disabled: _vm.isFetching },
            on: { click: _vm.addCart }
          },
          [
            _c("IconCart", { class: _vm.getClassName("add-cart__icon") }),
            _vm._v("カートに入れる\n  ")
          ],
          1
        )
      : _c("div", { class: _vm.getClassName("add-cart__message") }, [
          _vm._v("\n    現在のカートにこの商品は追加できません。"),
          _c("br"),
          _vm._v("先に購入手続きをお済ませ下さい。\n  ")
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }